import React, { useState, useEffect, useCallback } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { requestForToken, onMessageListener } from './FirebaseInitialize'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { InteractorAccountNotificationToken } from '../interactors/Main'
import { FetchSummaryHeader } from '../redux/summary/header/actionCreator'
import { removeCookies } from '../utility/Cookies'
import { useTranslation } from 'react-i18next'

const FirebaseNotification = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { account } = useSelector((state) => state.account)
  const { header_info } = useSelector((state) => state.summaryHeader)
  const { syncToken } = InteractorAccountNotificationToken()
  const [notification, setNotification] = useState({ title: '', body: '' })
  const notify = () => toast(<ToastDisplay />)
  function ToastDisplay() {
    return (
      <div className="container-notif">
        <Link to={'/notification'} className="text-dark">
          <div className="row align-items-center">
            <div className="col-2">
              <i className="fa fa-exclamation-circle notification-icon"></i>
            </div>
            <div className="col-10 notification-title">
              <strong>
                <div>{notification?.title}</div>
              </strong>
              <div className="notificatin-body">{notification?.body}</div>
            </div>
          </div>
          <hr></hr>
          <div className="row align-items-center justify-content-end px-2 notification-bottom">
            <div>{t('title.view_more')}</div>
          </div>
        </Link>
      </div>
    )
  }

  const getToken = useCallback(async () => {
    const browser_token = await requestForToken()
    if (browser_token && browser_token !== account?.notification_token) {
      syncToken(account, browser_token)
    }
  }, [account, syncToken])

  useEffect(() => {
    getToken()

    if (notification?.title) {
      notify()
    }
  }, [getToken, notification])

  if (onMessageListener) {
    onMessageListener()
      .then((payload) => {
        if (payload?.data?.notification_target === 'CUSTOMER') {
          // RESET BADGE
          removeCookies('summary-header')
          let summary = { ...header_info }
          if (payload?.data?.notification_type !== 'NEW-CHAT') {
            summary.notification_unread += 1
          } else {
            summary.chat_unread += 1
          }
          dispatch(FetchSummaryHeader(summary))
          // END RESET BADGE

          setNotification({
            title: payload?.notification?.title,
            body: payload?.notification?.body,
          })
        }
      })
      .catch(() => {})
  }

  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        className: '',
        duration: 5000,
      }}
    />
  )
}

export default FirebaseNotification
